import "./TypingIndicator.scss";

type DotSize = "xs" | "sm" | "md" | "lg";
type DotColor = "light" | "dark";

interface TypingIndicatorProps {
  /** Dot size variant (default: "md") */
  size?: DotSize;
  /** Dot color — "light" for dark backgrounds, "dark" for light backgrounds (default: "light") */
  color?: DotColor;
}

/**
 * Animated typing indicator — 3 bouncing dots.
 * Purely decorative — hidden from screen readers via aria-hidden.
 * Adjacent text elements should convey the status meaning.
 */
export default function TypingIndicator({
  size = "md",
  color = "light",
}: TypingIndicatorProps): JSX.Element {
  return (
    <span
      className={`ai-typing-dots ai-typing-dots--${size} ai-typing-dots--${color}`}
      aria-hidden="true"
      data-test-id="typing-indicator"
    >
      <span className="ai-dot" data-test-id="typing-dot" />
      <span className="ai-dot" data-test-id="typing-dot" />
      <span className="ai-dot" data-test-id="typing-dot" />
    </span>
  );
}
